export default "__VITE_ASSET__DcIxyd3q__"